import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { authApi } from '#services/auth';
import { cartApi } from '#services/cart';
import { orderApi } from '#services/order';

interface MiscState {
  cartItemCount: number;
}

const initialState: MiscState = {
  cartItemCount: 0,
};

export const miscSlice = createSlice({
  name: 'misc',
  initialState,
  reducers: {
    setCartItemCount(state, action: PayloadAction<number>) {
      state.cartItemCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
        state.cartItemCount = action.payload.cartItemCount;
      })
      .addMatcher(authApi.endpoints.check.matchFulfilled, (state, action) => {
        state.cartItemCount = action.payload.cartItemCount || 0;
      })
      .addMatcher(cartApi.endpoints.getCart.matchFulfilled, (state, action) => {
        state.cartItemCount = action.payload.items.length;
      })
      .addMatcher(cartApi.endpoints.addToCart.matchFulfilled, (state, _action) => {
        state.cartItemCount += 1;
      })
      .addMatcher(cartApi.endpoints.removeFromCart.matchFulfilled, (state, _action) => {
        state.cartItemCount -= 1;
      })
      .addMatcher(cartApi.endpoints.clearCart.matchFulfilled, (state, action) => {
        state.cartItemCount = action.payload.cartItemCount || 0;
      })
      .addMatcher(orderApi.endpoints.checkoutOrders.matchFulfilled, (state, _action) => {
        state.cartItemCount = 0;
      });
  },
});

export const {
  setCartItemCount,
} = miscSlice.actions;

export default miscSlice.reducer;
